import React, { memo } from "react";
import {
  Box,
  CircularProgress,
  OutlinedInput,
  Typography,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItemButton,
  ListItemText,
  Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const SidebarFilters = memo(
  ({
    filteredResults,
    categoryData,
    onArtistSelect,
    onCategorySelect,
    onReset,
    hasActiveFilter,
    query,
    setQuery,
    limit,
    setLimit, // Siguraduhin na pinasa mo ito mula sa Parent
    loadingCat,
  }) => {
    // Logic para malaman kung kailan ipapakita ang "See All"
    const showSeeAll = !query && filteredResults.length > 10;

    return (
      <Box sx={{ width: 280, p: { xs: 2, lg: 0 }, pr: { lg: 3 } }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 2, mt: 1, minHeight: "32px" }}
        >
          <Typography
            sx={{
              fontWeight: 800,
              fontSize: "0.7rem",
              letterSpacing: 1.5,
              color: "#000",
            }}
          >
            FILTERS
          </Typography>
          {hasActiveFilter && (
            <Button
              onClick={onReset}
              size="small"
              sx={{
                fontSize: "0.6rem",
                fontWeight: 900,
                color: "#000",
                border: "1px solid #000",
                borderRadius: 0,
                px: 1,
              }}
            >
              RESET
            </Button>
          )}
        </Stack>

        <Accordion
          defaultExpanded
          elevation={0}
          disableGutters
          sx={{ "&:before": { display: "none" }, borderTop: "1px solid #eee" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ fontSize: "1rem" }} />}
            sx={{ px: 0 }}
          >
            <Typography sx={{ fontWeight: 700, fontSize: "0.75rem" }}>
              ARTIST
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ px: 0, pb: 2 }}>
  <OutlinedInput
    fullWidth
    size="small"
    placeholder="Find artist..."
    value={query}
    onChange={(e) => setQuery(e.target.value)}
    sx={{ mb: 1, borderRadius: 0, fontSize: "0.8rem" }}
  />
  
  {loadingCat ? (
    <CircularProgress size={20} />
  ) : (
    <>
      
      <List sx={{ maxHeight: 350, overflow: "auto" }}>
        {filteredResults
          .filter((o) =>
            o.artist.toLowerCase().includes(query.toLowerCase())
          )
          .sort((a, b) =>
            a.artist.localeCompare(b.artist, undefined, {
              sensitivity: "base",
            })
          )
          .slice(0, query ? 100 : limit)
          .map((row, i) => {
            const cleanArtist = row.artist.split(/<br\s*\/?>|\n/i)[0].trim();
            const cleanArtistRemoveBR = row.artist
              .replace(/<br\s*\/?>/gi, " ")
              .replace(/\n/g, " ")
              .trim();

            return (
              <ListItemButton
                key={i}
                onClick={() => onArtistSelect(cleanArtist)}
                sx={{
                  px: 1,
                  py: 0.5,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <ListItemText
                  primary={cleanArtistRemoveBR}
                  primaryTypographyProps={{ fontSize: "0.8rem" }}
                />
                <Typography
                  sx={{
                    fontSize: "0.7rem",
                    color: "#999",
                    fontWeight: 600,
                  }}
                >
                  {row.total}
                </Typography>
              </ListItemButton>
            );
          })}
      </List>

      
      {showSeeAll && (
        <Button
          fullWidth
          onClick={() =>
            setLimit(limit === 10 ? filteredResults.length : 10)
          }
          sx={{
            justifyContent: "flex-start",
            fontSize: "0.7rem",
            fontWeight: 700,
            color: "#000",
            textDecoration: "underline",
            mt: 1,
            py: 1, // Dinagdagan ng padding para mas madaling mapindot sa mobile
            "&:hover": {
              textDecoration: "underline",
              background: "none",
            },
          }}
        >
          {limit === 10
            ? `SEE ALL (${filteredResults.length})`
            : "SEE LESS"}
        </Button>
      )}
    </>
  )}
</AccordionDetails>
        </Accordion>

        
        <Accordion
          defaultExpanded
          elevation={0}
          disableGutters
          sx={{
            "&:before": { display: "none" },
            borderTop: "1px solid #eee",
            borderBottom: "1px solid #eee",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ fontSize: "1rem" }} />}
            sx={{ px: 0 }}
          >
            <Typography sx={{ fontWeight: 700, fontSize: "0.75rem" }}>
              CATEGORY
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ px: 0, pb: 2 }}>
            <List>
              {categoryData.map((row, i) => (
                <ListItemButton
                  key={i}
                  onClick={() => onCategorySelect(row.categories)}
                  sx={{
                    px: 1,
                    py: 0.5,
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <ListItemText
                    primary={row.categories}
                    primaryTypographyProps={{ fontSize: "0.8rem" }}
                  />
                  <Typography
                    sx={{ fontSize: "0.7rem", color: "#999", fontWeight: 600 }}
                  >
                    {row.total}
                  </Typography>
                </ListItemButton>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      </Box>
    );
  }
);

export default SidebarFilters;
